import { Worker } from "../util";
import angular from "angular";

export default class FilteredListCtrl{

  constructor(persistentFilter = true){
    this.items = [];
    this.load = Worker(this._load);
    this.filter = this.getDefaultFilter();
    this.persistentFilter = persistentFilter;
    this.autoLoadFilter();
  }

  _load(){
    throw "Not implemented";
  }

  show(items){
    this.activeFilter = angular.copy(this.filter);
    this.autoSaveFilter();
    this.items = items;
  }

  getDefaultFilter(){
    return this.getEmptyFilter();
  }

  getEmptyFilter(){
    return {};
  }

  isFilterActive(){
    return !angular.equals(this.activeFilter, this.getEmptyFilter());
  }

  resetFilter(){
    this.filter = this.getEmptyFilter();
    this.load();
  }

  autoLoadFilter(){
    if(this.persistentFilter) this.loadFilter();
  }

  loadFilter(id){
    try{
      if(!id) id = "FILTER-"+this.constructor.name;
      if(window.localStorage && window.localStorage.getItem){
        var filterStr = window.localStorage.getItem(id);
        console.log("loading", id);
        if(filterStr){
          this.filter = JSON.parse(filterStr);
          console.log("loaded", this.filter);
        }
      }
    }catch(e){}
  }

  autoSaveFilter(){
    if(this.persistentFilter) this.saveFilter();
  }

  saveFilter(id){
    try{
      if(!id) id = "FILTER-"+this.constructor.name;
      if(window.localStorage && window.localStorage.setItem){
        window.localStorage.setItem(id, JSON.stringify(this.activeFilter));
        console.log("saved", this.activeFilter);
      }
    }catch(e){}
  }

}


// WEBPACK FOOTER //
// ./src/common/FilteredListCtrl.js